import React, { useState } from 'react';
import {
  StyledCard,
  StyledBox,
  StyledTitle,
  StyledTypography,
} from 'pages/ApplyOnlinePage/ApplyOnlineCard/styles';
import { EButtonVariants } from 'constants/Buttons';
import Button from 'components/atoms/Button';
import { useNavigate } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import { FormModal } from 'components/molecules/Modal';
import { Checkbox, Grid, Typography } from '@mui/material';
import { colors } from 'theme/colors';
import { RouterLink } from 'components/atoms/RouterLink';
import { IApplyCardData } from 'pages/ApplyOnlinePage';

interface IApplyOnlineCard {
  item: IApplyCardData;
}

const ApplyOnlineCard = ({ item }: IApplyOnlineCard) => {
  const navigate = useNavigate();
  const [confirmationApply, setConfirmationApply] = useState(false);
  const [confirmGuidance, setConfirmGuidance] = useState(false);

  return (
    <StyledCard>
      <StyledTitle variant="h5">{item.title}</StyledTitle>

      <FormModal
        title={item.applyModalTitle}
        open={confirmationApply}
        onClickClose={() => setConfirmationApply(false)}
        onClickApprove={() => (item.link ? navigate(ERouteLinks.ApplyOnlineWizard) : () => {})}
        approveButtonDisabled={!confirmGuidance}
        approveButtonLabel="continue"
        cancelButtonLabel="cancel"
        minWidth="670px"
        maxWidth="670px"
      >
        <Grid container gap="20px">
          <Typography variant="body1">
            You will need to have read <RouterLink to="" label="the guidance notes" /> before
            making your application.
          </Typography>
          <Grid container gap={1}>
            <Typography variant="body1" style={{ fontWeight: 600 }}>
              Have you read the guidance notes before making this application?
            </Typography>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Checkbox
                sx={{
                  color: colors.gray400,
                  padding: 0,
                }}
                checked={confirmGuidance}
                onClick={() => setConfirmGuidance(!confirmGuidance)}
              />
              <Typography variant="body1">
                I confirm I have read the guidance notes which support this application.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </FormModal>
      <StyledBox>
        <div>
          <StyledTypography variant="body1">
            Certificate Description: <span>{item.description}</span>
          </StyledTypography>

          <StyledTypography variant="body1">
            Certificate Duration: <span>{item.duration} Years</span>
          </StyledTypography>

          <StyledTypography variant="body1">
            Firearm Number Limit: <span>{item.numberOfFirearms}</span>
          </StyledTypography>

          <StyledTypography variant="body1">
            Minimum age: <span>{item.minimumAge}</span>
          </StyledTypography>

          <StyledTypography variant="body1">
            Fee: <span>{item.fee} GBP</span>
          </StyledTypography>
        </div>
        <Button variant={EButtonVariants.text} label="More info" fullWidth />
      </StyledBox>
      <Button
        variant={EButtonVariants.contained}
        label={item.applyButtonLabel}
        fullWidth
        onClick={() => setConfirmationApply(true)}
      />
    </StyledCard>
  );
};

export { ApplyOnlineCard };
